<div>
    <div class="row" style="margin:0px" >
        <span class="modal-sub-header">
            Select Nursing Stations: 
            <span class="modal-sub-header" 
                  style="margin-left: 10px;">
                  <a (click)="selectAllNursingStations()">Select All</a>
            </span>
        </span>
        <div class="scrollable-content-area">
            <div *ngFor="let nursingStation of nursingStations">
                <label [class]="areAllNursingStationsSelected ? 'checkbox-square' : 'checkbox'">
                    <input type="checkbox" 
                        (change)="selectNursingStation()" 
                        [(ngModel)]="nursingStation.IsSelected">
                    <span></span>
                    <span class="checkbox-label">
                        {{nursingStation.FacilityName}} - {{nursingStation.NursingStationName}}
                    </span>
                </label>
            </div>
        </div>
    </div>
</div>